import {
  useAnchorCardContext,
  useFacetContext,
  useProductContext,
  useRouterContext,
} from '../../../context/PlpContext';
import { useExperiencesContext } from '../../experiences/Experiences';
import { useProductCardSize } from '../../../hooks/useProductCardSize';
import { usePlpViewType } from '../../../hooks/usePlpViewType';

export const useProductListingData = () => {
  const { anchorCard } = useAnchorCardContext();

  const experiencesContext = useExperiencesContext();

  const { isLargeCardSize } = useProductCardSize();

  const { hasPlpViewTypeSelection, isListView } = usePlpViewType(
    'useProductListingData'
  );

  const facetContext = useFacetContext();

  const { pagesAvailable } = useProductContext();

  const router = useRouterContext();

  return {
    anchorCard,
    experiencesContext,
    facetContext,
    pagesAvailable,
    isLargeCardSize,
    isListView,
    hasPlpViewTypeSelection,
    router,
  };
};
